module.exports = __webpack_public_path__ + "img/spotify.31bad8d4.png";